import React from 'react';
import './RedditPosts.css';

const RedditPosts = () => {
  const commonQuestions = [
    {
      id: 1,
      question: "What should I ask my doctor during my consultation?",
      keyFactors: [
        "60% dug into clinic stats — they wanted data and success rates (esp. from SART or CDC)",
        "50% were with what they could actually afford (full cost breakdowns mattered)",
        "40% needed a clinic that fit into their daily life — early AM appts, close to work, flexible timing",
        "30% based it on how the doctor made them feel — rushed vs. seen",
        "20% looked for a woman doctor they could trust and feel safe with"
      ],
      summary: "So yeah, it was part research, part vibes, part logistics. Most didn't pick just the 'top-rated' clinic — they picked the one that felt right for them."
    },
    {
      id: 2,
      question: "How do I plan to finance my journey?",
      keyFactors: [
        "Research insurance coverage and benefits",
        "Look into fertility financing programs",
        "Consider clinic payment plans",
        "Explore grants and financial assistance",
        "Plan for medication costs separately"
      ]
    },
    {
      id: 3,
      question: "When should I freeze my eggs?",
      keyFactors: [
        "Consider age and fertility timeline",
        "Review hormone levels and test results",
        "Evaluate career and life plans",
        "Understand success rates by age",
        "Factor in cost and insurance coverage"
      ]
    }
  ];

  return (
    <div className="reddit-qa">
      {commonQuestions.map((item) => (
        <div key={item.id} className="qa-section">
          <h3>{item.question}</h3>
          <div className="key-factors">
            <h4>Key Factors</h4>
            <ul>
              {item.keyFactors.map((factor, index) => (
                <li key={index}>{factor}</li>
              ))}
            </ul>
          </div>
          {item.summary && (
            <p className="summary">{item.summary}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default RedditPosts; 